import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=b523a7a4&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=b523a7a4&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b523a7a4",
  null
  
)

export default component.exports